module.exports = __webpack_public_path__ + "static/media/IEG.0c541806.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/IEG.jpg
// module id = 2238
// module chunks = 0